import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Truck } from 'lucide-react';
import type { FilterState } from '../GlobalFilters';

interface LogisticsTabProps {
  clientId: string;
  filters: FilterState;
}

export function LogisticsTab({ clientId, filters }: LogisticsTabProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <Truck className="mr-2 h-5 w-5" />
          Logistique & Livraison
        </CardTitle>
        <CardDescription>Performance des expéditions et livraisons</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">Données logistiques en cours de chargement...</p>
      </CardContent>
    </Card>
  );
}